import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "../layouts/AppLayout";
import { DashboardPage } from "../features/dashboard/DashboardPage";
import { ExperimentsPage } from "../features/experiments/ExperimentsPage";
import { RecommendationsPage } from "../features/recommendations/RecommendationsPage";
import PatientSelectorTest from "../routes/patient-selector-test";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "experiments",
        element: <ExperimentsPage />,
      },
      {
        path: "recommendations",
        element: <RecommendationsPage />,
      },
      {
        path: "patient-selector-test",
        element: <PatientSelectorTest />,
      },
    ],
  },
]);
